import axiosInstance from "../../api/axiosInstance";
import { CH_ONDC_AES_KEY, get_application_entry, get_initialize_payment_url_kmc, get_prop_outstanding, get_water_tax_details, get_license_payment_details, get_general_demand_Service_details, get_grievance_details_url, get_kmc_department_details_url, get_kmc_subcategory_details_url, get_kmc_submit_grievance_url } from "../../utills/constants";
import { AesECBEncrypt } from "../../utills/encryption";
// ==================== Property Details ====================
export const KMC_FETCH_PROPERTY_REQUEST = "KMC_FETCH_PROPERTY_REQUEST";
export const KMC_FETCH_PROPERTY_SUCCESS = "KMC_FETCH_PROPERTY_SUCCESS";
export const KMC_FETCH_PROPERTY_FAILURE = "KMC_FETCH_PROPERTY_FAILURE";

export const kmcFetchPropertyRequest = () => ({ type: KMC_FETCH_PROPERTY_REQUEST });
export const kmcFetchPropertySuccess = (data) => ({ type: KMC_FETCH_PROPERTY_SUCCESS, payload: data });
export const kmcFetchPropertyFailure = (error) => ({ type: KMC_FETCH_PROPERTY_FAILURE, payload: error });

export const kmcGetPropertyDetails = (payload) => async (dispatch) => {
  dispatch(kmcFetchPropertyRequest());

  try {
    //payload.service_code = "N";
    //payload.consumerno =  payload.consumerNumber;
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    const response = await axiosInstance.post(get_prop_outstanding(), encryptedBody);

    if (!response?.data) throw new Error("No property data found for this number.");

    dispatch(kmcFetchPropertySuccess(response.data));
  } catch (error) {
    console.error("Error fetching property details:", error);
    dispatch(
      kmcFetchPropertyFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Payment ====================
export const KMC_INIT_PAYMENT_REQUEST = "KMC_INIT_PAYMENT_REQUEST";
export const KMC_INIT_PAYMENT_SUCCESS = "KMC_INIT_PAYMENT_SUCCESS";
export const KMC_INIT_PAYMENT_FAILURE = "KMC_INIT_PAYMENT_FAILURE";

export const kmcInitPaymentRequest = () => ({ type: KMC_INIT_PAYMENT_REQUEST });
export const kmcInitPaymentSuccess = (data) => ({ type: KMC_INIT_PAYMENT_SUCCESS, payload: data });
export const kmcInitPaymentFailure = (error) => ({ type: KMC_INIT_PAYMENT_FAILURE, payload: error });

export const kmcInitializePayment = (payload) => async (dispatch) => {
  console.log("skskPay", payload);
  dispatch(kmcInitPaymentRequest());

  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    const response = await axiosInstance.post(get_initialize_payment_url_kmc(), encryptedBody);

    if (!response?.data) throw new Error("Payment initialization failed.");

    dispatch(kmcInitPaymentSuccess(response.data));
  } catch (error) {
    console.error("Payment initialization error:", error);
    dispatch(
      kmcInitPaymentFailure(
        error.response?.data?.message || error.message || "Payment failed"
      )
    );
  }
};
// ==================== Application Entry ====================
export const KMC_APPLICATION_ENTRY_REQUEST = "KMC_APPLICATION_ENTRY_REQUEST";
export const KMC_APPLICATION_ENTRY_SUCCESS = "KMC_APPLICATION_ENTRY_SUCCESS";
export const KMC_APPLICATION_ENTRY_FAILURE = "KMC_APPLICATION_ENTRY_FAILURE";

export const kmcApplicationEntryRequest = () => ({
  type: KMC_APPLICATION_ENTRY_REQUEST,
});

export const kmcApplicationEntrySuccess = (data) => ({
  type: KMC_APPLICATION_ENTRY_SUCCESS,
  payload: data,
});

export const kmcApplicationEntryFailure = (error) => ({
  type: KMC_APPLICATION_ENTRY_FAILURE,
  payload: error,
});

export const kmcApplicationEntry = (payload) => async (dispatch) => {
  dispatch(kmcApplicationEntryRequest());

  try {
    // Optional: attach additional info required by backend
    // Example: payload.ServiceCode = "N";

    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    const response = await axiosInstance.post(get_application_entry(), encryptedBody);

    if (!response?.data) throw new Error("Application Entry failed or returned empty data.");

    dispatch(kmcApplicationEntrySuccess(response.data));
  } catch (error) {
    console.error("Application Entry API error:", error);
    dispatch(
      kmcApplicationEntryFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};
// ==================== Water Tax Details ====================
export const KMC_WATER_TAX_REQUEST = "KMC_WATER_TAX_REQUEST";
export const KMC_WATER_TAX_SUCCESS = "KMC_WATER_TAX_SUCCESS";
export const KMC_WATER_TAX_FAILURE = "KMC_WATER_TAX_FAILURE";

export const kmcWaterTaxRequest = () => ({ type: KMC_WATER_TAX_REQUEST });
export const kmcWaterTaxSuccess = (data) => ({ type: KMC_WATER_TAX_SUCCESS, payload: data });
export const kmcWaterTaxFailure = (error) => ({ type: KMC_WATER_TAX_FAILURE, payload: error });

export const kmcGetWaterTaxDetails = (payload) => async (dispatch) => {
  dispatch(kmcWaterTaxRequest());
  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    const response = await axiosInstance.post(get_water_tax_details(), encryptedBody);
    if (!response?.data) throw new Error("No water tax details found.");

    dispatch(kmcWaterTaxSuccess(response.data));
  } catch (error) {
    console.error("Error fetching water tax details:", error);
    dispatch(
      kmcWaterTaxFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== License Fee / License Payment Details ====================
export const KMC_LICENSE_FEE_REQUEST = "KMC_LICENSE_FEE_REQUEST";
export const KMC_LICENSE_FEE_SUCCESS = "KMC_LICENSE_FEE_SUCCESS";
export const KMC_LICENSE_FEE_FAILURE = "KMC_LICENSE_FEE_FAILURE";
export const kmcLicenseFeeRequest = () => ({
  type: KMC_LICENSE_FEE_REQUEST,
});

export const kmcLicenseFeeSuccess = (data) => ({
  type: KMC_LICENSE_FEE_SUCCESS,
  payload: data,
});

export const kmcLicenseFeeFailure = (error) => ({
  type: KMC_LICENSE_FEE_FAILURE,
  payload: error,
});


export const kmcGetLicenseFeeDetails = (payload) => async (dispatch) => {
  dispatch(kmcLicenseFeeRequest());

  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);

    const response = await axiosInstance.post(
      get_license_payment_details(),
      encryptedBody
    );

    if (!response?.data) {
      throw new Error("No license fee details found.");
    }

    dispatch(kmcLicenseFeeSuccess(response.data));
  } catch (error) {
    console.error("Error fetching license fee details:", error);
    dispatch(
      kmcLicenseFeeFailure(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      )
    );
  }
};

// ==================== General Demand Service ====================
export const KMC_GENERAL_DEMAND_REQUEST = "KMC_GENERAL_DEMAND_REQUEST";
export const KMC_GENERAL_DEMAND_SUCCESS = "KMC_GENERAL_DEMAND_SUCCESS";
export const KMC_GENERAL_DEMAND_FAILURE = "KMC_GENERAL_DEMAND_FAILURE";

export const kmcGeneralDemandRequest = () => ({
  type: KMC_GENERAL_DEMAND_REQUEST,
});

export const kmcGeneralDemandSuccess = (data) => ({
  type: KMC_GENERAL_DEMAND_SUCCESS,
  payload: data,
});

export const kmcGeneralDemandFailure = (error) => ({
  type: KMC_GENERAL_DEMAND_FAILURE,
  payload: error,
});

export const kmcGetGeneralDemandServiceDetails = (payload) => async (dispatch) => {
  dispatch(kmcGeneralDemandRequest());

  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);

    const response = await axiosInstance.post(
      get_general_demand_Service_details(),
      encryptedBody
    );

    if (!response?.data) {
      throw new Error("No general demand service details found.");
    }

    dispatch(kmcGeneralDemandSuccess(response.data));
  } catch (error) {
    console.error("Error fetching general demand service details:", error);
    dispatch(
      kmcGeneralDemandFailure(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      )
    );
  }
};

// ==================== Grievance Details ====================
export const KMC_GRIEVANCE_DETAILS_REQUEST = "KMC_GRIEVANCE_DETAILS_REQUEST";
export const KMC_GRIEVANCE_DETAILS_SUCCESS = "KMC_GRIEVANCE_DETAILS_SUCCESS";
export const KMC_GRIEVANCE_DETAILS_FAILURE = "KMC_GRIEVANCE_DETAILS_FAILURE";

export const kmcGrievanceDetailsRequest = () => ({
  type: KMC_GRIEVANCE_DETAILS_REQUEST,
});

export const kmcGrievanceDetailsSuccess = (data) => ({
  type: KMC_GRIEVANCE_DETAILS_SUCCESS,
  payload: data,
});

export const kmcGrievanceDetailsFailure = (error) => ({
  type: KMC_GRIEVANCE_DETAILS_FAILURE,
  payload: error,
});

export const kmcGetGrievanceDetails = (payload) => async (dispatch) => {
  dispatch(kmcGrievanceDetailsRequest());

  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    const response = await axiosInstance.post(
      get_grievance_details_url(),
      encryptedBody
    );

    if (!response?.data) {
      throw new Error("No grievance details found.");
    }
    dispatch(kmcGrievanceDetailsSuccess(response.data));
  } catch (error) {
    console.error("Error fetching grievance details:", error);
    dispatch(
      kmcGrievanceDetailsFailure(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      )
    );
  }
};

// ==================== KMC Register Grievance: Department (Category) ====================
export const KMC_DEPARTMENT_REQUEST = "KMC_DEPARTMENT_REQUEST";
export const KMC_DEPARTMENT_SUCCESS = "KMC_DEPARTMENT_SUCCESS";
export const KMC_DEPARTMENT_FAILURE = "KMC_DEPARTMENT_FAILURE";

export const kmcDepartmentRequest = () => ({ type: KMC_DEPARTMENT_REQUEST });
export const kmcDepartmentSuccess = (data) => ({ type: KMC_DEPARTMENT_SUCCESS, payload: data });
export const kmcDepartmentFailure = (error) => ({ type: KMC_DEPARTMENT_FAILURE, payload: error });

export const kmcGetDepartmentDetails = () => async (dispatch) => {
  dispatch(kmcDepartmentRequest());
  try {
    const response = await axiosInstance.get(get_kmc_department_details_url());
    if (!response?.data) throw new Error("No department details found.");
    dispatch(kmcDepartmentSuccess(response.data));
  } catch (error) {
    dispatch(kmcDepartmentFailure(error.response?.data?.message || error.message || "Something went wrong"));
  }
};

// ==================== KMC Register Grievance: Subcategory ====================
export const KMC_SUBCATEGORY_REQUEST = "KMC_SUBCATEGORY_REQUEST";
export const KMC_SUBCATEGORY_SUCCESS = "KMC_SUBCATEGORY_SUCCESS";
export const KMC_SUBCATEGORY_FAILURE = "KMC_SUBCATEGORY_FAILURE";

export const kmcSubcategoryRequest = () => ({ type: KMC_SUBCATEGORY_REQUEST });
export const kmcSubcategorySuccess = (data) => ({ type: KMC_SUBCATEGORY_SUCCESS, payload: data });
export const kmcSubcategoryFailure = (error) => ({ type: KMC_SUBCATEGORY_FAILURE, payload: error });

export const kmcGetSubcategoryDetails = (categoryId) => async (dispatch) => {
  dispatch(kmcSubcategoryRequest());
  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, { category_id: categoryId });
    const response = await axiosInstance.post(get_kmc_subcategory_details_url(), encryptedBody);
    if (!response?.data) throw new Error("No subcategory details found.");
    dispatch(kmcSubcategorySuccess(response.data));
  } catch (error) {
    dispatch(kmcSubcategoryFailure(error.response?.data?.message || error.message || "Something went wrong"));
  }
};

// ==================== KMC Submit Grievance ====================
export const KMC_SUBMIT_GRIEVANCE_REQUEST = "KMC_SUBMIT_GRIEVANCE_REQUEST";
export const KMC_SUBMIT_GRIEVANCE_SUCCESS = "KMC_SUBMIT_GRIEVANCE_SUCCESS";
export const KMC_SUBMIT_GRIEVANCE_FAILURE = "KMC_SUBMIT_GRIEVANCE_FAILURE";

export const kmcSubmitGrievanceRequest = () => ({ type: KMC_SUBMIT_GRIEVANCE_REQUEST });
export const kmcSubmitGrievanceSuccess = (data) => ({ type: KMC_SUBMIT_GRIEVANCE_SUCCESS, payload: data });
export const kmcSubmitGrievanceFailure = (error) => ({ type: KMC_SUBMIT_GRIEVANCE_FAILURE, payload: error });

export const kmcSubmitGrievance = (payload) => async (dispatch) => {
  dispatch(kmcSubmitGrievanceRequest());
  try {
    const encryptedBody = AesECBEncrypt(CH_ONDC_AES_KEY, payload);
    const response = await axiosInstance.post(get_kmc_submit_grievance_url(), encryptedBody);
    if (!response?.data) throw new Error("Grievance submission failed.");
    dispatch(kmcSubmitGrievanceSuccess(response.data));
  } catch (error) {
    dispatch(kmcSubmitGrievanceFailure(error.response?.data?.message || error.message || "Something went wrong"));
  }
};
